import React, { useEffect, useState, useCallback } from "react";
//Components
import { NotificationManager } from "Components/Notifications";
import { Button, Input, Form, Modal } from "@gpstrackit/gtc-react-controls";

//Actions
import { useSelector, useDispatch } from "react-redux";
import { editCameraManagementEditCamera, reset } from "./redux/slice";

//Language
import { useIntl } from "react-intl";

const EditCameraManagementCamera = ({ refresh }) => {
  const dispatch = useDispatch();
  const { messages } = useIntl();
  const formRef = Form.useForm();

  //Local States
  const [formData, setFormData] = useState({});

  //Redux States
  const { open, loading, unit, result, error } = useSelector(
    (state) => state.editCameraManagementCameraRedux
  );

  const handleClose = useCallback(() => {
    dispatch(reset());
    setFormData({});
  });

  const applyChanges = () => {
    let payload = {
      id: unit?.id,
      label: formData?.label
    };
    dispatch(editCameraManagementEditCamera(payload));
  };

  useEffect(() => {
    if (open && formRef?.ref && unit) {
      let timer = setTimeout(() => {
        let payload = {
          label: unit?.label
        };
        formRef.setValues(payload);
        setFormData(payload);
        timer = null;
      }, 100);
    }
  }, [unit, formRef?.ref]);

  useEffect(() => {
    if (result) {
      NotificationManager.success(
        messages["manage_cameraManagement_editCamera_cameraUpdated"],
        messages["success"],
        3000
      );
      handleClose();
      refresh();
    }
    if (error) {
      NotificationManager.error(
        messages["manage_cameraManagement_editCamera_errorMessage"],
        messages["error"],
        3000
      );
      dispatch(reset({ error: null }));
    }
  }, [result, error]);

  return (
    <Modal
      title={`${messages["manage_cameraManagement_editCamera_title"]}  (${unit?.label})`}
      open={open}
      loading={loading}
      position="right"
      size="small"
      handleClose={() => handleClose()}
      footer={
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ marginRight: 8 }}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button onClick={(e) => formRef.submit()} variant="primary" isDisabled={loading}>
            {messages["save"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: 24 }}>
        <Form ref={formRef.ref} onValidSubmit={applyChanges}>
          <Form.Item
            name="label"
            label={messages["manage_cameraManagement_editCamera_label"]}
            rules={[{ required: true, message: "required_field" }]}
          >
            <Input
              id="label"
              type="text"
              placeholder={messages["manage_cameraManagement_editCamera_label"]}
              autoFocus
              maxLength={30}
              onChange={(value) => setFormData({ ...formData, label: value })}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default EditCameraManagementCamera;
